import { type ReactElement, type SVGProps } from 'react';

export const SurfaceDividableIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.5 3V1h1v2H21v14h-6.5v2h-1v-2H7V3h6.5ZM20 16V4H8v12h12ZM13.5 6v3h1V6h-1Zm0 8v-3h1v3h-1ZM3.5 1.793l1.854 1.853-.708.708L4 3.707v13.086l.646-.646.708.707L3.5 18.708l-1.854-1.854.708-.707.646.646V3.707l-.646.647-.708-.708L3.5 1.793ZM22.207 20.5l-1.853-1.854-.707.708.646.646H7.207l.647-.646-.708-.708L5.293 20.5l1.853 1.854.708-.708L7.207 21h13.086l-.646.646.707.708 1.854-1.854Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
